import { UploadFile } from "antd/es/upload/interface";
import { MetadataItem, UploadProgressEvent } from "../../../api/data-types";
import { StorageAPIClient } from "../../../api/storage-api-client";

const DEFAULT_CONTAINER_LABEL = "";

export function uploadAFileWithMetadataFile(
  aContainerName: string,
  aFile: UploadFile,
  aMetadata: MetadataItem[],
  onProgress: (ev: UploadProgressEvent) => void,
  aFolder?: string,
  aFileName?: string
): Promise<number> {
  return StorageAPIClient.uploadFileWithMetadataFile(
    aContainerName,
    aFile,
    aMetadata,
    onProgress,
    aFolder,
    aFileName
  )
    .then((response) => {
      const status = (response.data.status === "Success" ? 200 : 400) as number;
      return status;
    })
    .catch((error) => {
      console.error("Upload Failed:", error);
      return 500;
    });
}

export const selectFolderTooltipConditions = (
  container: string,
  isDictionaryComplete: boolean
): string => {

  if (container === DEFAULT_CONTAINER_LABEL) {
    return "Select container to enable folder choosing";
  } else if (!isDictionaryComplete) {
    return "Provide necessary metadata to enable folder choosing";
  } else {
    return "";
  }
};

export const submitButtonTooltipConditions = (
  fileListLenght: number,
  container: string,
  isDictionaryComplete: boolean
) => {
  if (fileListLenght === 0 || container === "") {
    return "Select container and file before uploading";
  } else if (!isDictionaryComplete) {
    return "Provide necessary metadata required by container folder structure";
  } else {
    return "";
  }
};

export const filterOnlyMetadataItems = (elements: string[]): string[] => {
  const pattern = /%metadata\['(.*?)'\]%/g;

  const matchingValues: string[] = [];
  elements.forEach((entry) => {
    const match = entry.match(pattern);
    if (match !== null) {
      match.forEach((uneditedKey) => {
        uneditedKey = uneditedKey.replace(/%metadata\['(.*?)'\]%/, '$1');
        uneditedKey = uneditedKey.toLowerCase();
        matchingValues.push(uneditedKey);
      })
    }
  });

  return matchingValues;
};

export const filterOnlyProfileItems = (elements: string[]): string[] => {
  const pattern = /%profile\.(.*?)%/g;

  const matchingValues: string[] = [];
  elements.forEach((entry) => {
    const match = entry.match(pattern);
    if (match !== null) {
      match.forEach((uneditedKey) => {
        uneditedKey = uneditedKey.replace(/%profile\.(.*?)%/, '$1');
        matchingValues.push(uneditedKey);
      })
    }
  });

  return matchingValues;
}; 
